import React, { useState, useEffect } from "react";
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, InputBase, Pagination, Menu, MenuItem,CircularProgress
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CustomText, { textStyles } from "../../../../components/CustomText";
import StatusDropdown from "../../../../components/StatusDropdown";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import emptypayment from "../../../../assets/emptypayment.png";
import { formatCalendarDateForDisplay } from "../../../../components/dateTimeUtils";
const HeaderStyles = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const DataStyles = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const WorkerRequest = ({workerId}) => {
  const { t } = useTranslation();

  const [requests, setRequests] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({});
  const [loading, setLoading] = useState(false);
const [refreshList, setRefreshList] = useState(false);

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
const [initialLoading, setInitialLoading] = useState(true);   // full screen loader
const [tableLoading, setTableLoading] = useState(false); 
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
const { company } = useSelector((state) => state.auth);
const companyId = company?.id;
console.log(companyId)
const [filterOpen, setFilterOpen] = useState(false);
const [filters, setFilters] = useState({ status: "", startDate: "", endDate: "" });

const fetchRequests = async (page = 1, limit = 5, isInitial = false, appliedFilters = filters) => {
  try {
    if (isInitial) setInitialLoading(true);
    else setTableLoading(true);

    const { status, startDate, endDate } = appliedFilters;
    let query = `search=${search}&page=${page}&limit=${limit}`;
    if (status) query += `&status=${status}`;
    if (startDate) query += `&start_date=${startDate}`;
    if (endDate) query += `&end_date=${endDate}`;
//     if (appliedFilters.startDate) filterQuery += `&from=${appliedFilters.startDate}`;
// if (appliedFilters.endDate) filterQuery += `&to=${appliedFilters.endDate}`;

    const res = await fetch(
      `${BASE_URL}/requests/v1/companies/${companyId}/requests?${query}&worker=${workerId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    setRequests(data.data || []);
    setPaginationInfo(data.pagination || {});
  } catch (err) {
    console.error("Failed to fetch requests", err);
  } finally {
    setInitialLoading(false);
    setTableLoading(false);
  }
};


const [didMount, setDidMount] = useState(false);

useEffect(() => {
  fetchRequests(currentPage, 5, true);   // first load with big loader
  setDidMount(true);
}, []);

useEffect(() => {
  if (didMount) {
    fetchRequests(currentPage, 5);   // subsequent loads with small loader
  }
}, [currentPage, refreshList, search, didMount]);
  // Filter by search
  const filteredData = requests.filter(
    (row) =>
      row.type?.toLowerCase().includes(search.toLowerCase()) ||
      row.leave_reason_text?.toLowerCase().includes(search.toLowerCase()) ||
      row.status?.toLowerCase().includes(search.toLowerCase())
  );
const formatDate = (dateString) => {
  const formatted = formatCalendarDateForDisplay(dateString, { locale: "en-GB" });
  return formatted === "—" ? "-" : formatted;
};
  return (
    <Box sx={{ backgroundColor: "white", borderRadius: 2, border: "2px solid #091E4224", py: 2, px: 2, mt: 1, ml:1, mr:1 }}>
      
      {/* Header */}
      <Box
        sx={{
          pb: 2,
          borderBottom: "2px solid #091E4224",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  <CustomText
    sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149" }}
  >
    {t("requestManagement.heading")}
  </CustomText>
  {tableLoading && !initialLoading && (
    <CircularProgress size={20} />
  )}</Box>
        {/* Search */}
        <Box
          sx={{
            px: 1,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: "2px solid #091E4224",
            display: "flex",
            alignItems: "center",
            minWidth: 250,
            maxWidth: 300,
          }}
        >
          <InputBase
            placeholder={t("requestManagement.searchPlaceholder")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              color: "#939393",
              width: "100%",
            }}
          />
          <SearchIcon sx={{ fontSize: 20, color: "#888", ml: 1 }} />
        </Box>

        {/* Export & Filter */}
 
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.id")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.type")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.reason")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.date")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.comments")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.status")}</TableCell>
            
            </TableRow>
          </TableHead>

          <TableBody>
            {initialLoading ? (
              <TableRow>
                <TableCell colSpan={7} align="center"><CircularProgress size={40} /></TableCell>
              </TableRow>
            ) : filteredData.length > 0 ? (
              filteredData.map((row, i) => (
                <TableRow key={i}>
                  <TableCell sx={DataStyles}>{row.id}</TableCell>
                  <TableCell sx={DataStyles}>{row.type}</TableCell>
                  <TableCell sx={DataStyles}>
                    {/* {row.leave_reason_text || "-"}
                     */}
                               <TruncatedCell text={row.leave_reason_text || "-"}/>
                     
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    {formatDate(row.created_at)}
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    {row.admin_comment || "-"}
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    <Box sx={{ pointerEvents: "none" }}>
                      <StatusDropdown currentStatus={row.status} />
                    </Box>
                  </TableCell>
                  
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 5,
              }}
            >
              <img
                src={emptypayment}
                alt="No Data"
                style={{ width: 200, marginBottom: 16 }}
              />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#003149",
                }}
              >
                {t("empty.no_user")}
              </CustomText>
            </Box></TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>



      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={paginationInfo.pages || 1}
          page={currentPage}
          onChange={(_, val) => setCurrentPage(val)}
          shape="rounded"
          color="primary"
          size="small"
                sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: 13,
                  fontWeight: 500,
                },
                "& .Mui-selected": {
                  backgroundColor: "#E9F3FF",
                  color: "#006EC2",
                },
              }}
        />
      </Box>

  


  </Box>
  );
};

export default WorkerRequest;